import type { TaxRate } from '@/pages/sidebar/SettingsPage/types';

const STORAGE_KEY = 'drahft_tax_rates';

const SAMPLE_TAX_RATES: TaxRate[] = [
  { id: 'tax-1', name: 'GST Included', rate: 10, inclusion: 'inclusive' },
  { id: 'tax-2', name: 'HST', rate: 13, inclusion: 'exclusive' },
];

const isValidTaxRate = (item: unknown): item is TaxRate => {
  if (!item || typeof item !== 'object') {
    return false;
  }

  const value = item as TaxRate;

  return (
    typeof value.id === 'string' &&
    typeof value.name === 'string' &&
    typeof value.rate === 'number' &&
    Number.isFinite(value.rate) &&
    (value.inclusion === 'inclusive' || value.inclusion === 'exclusive')
  );
};

export const loadTaxRates = (): TaxRate[] => {
  if (typeof window === 'undefined') {
    return SAMPLE_TAX_RATES;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return SAMPLE_TAX_RATES;
    }

    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return SAMPLE_TAX_RATES;
    }

    const rates = parsed.filter(isValidTaxRate);
    return rates.length > 0 ? rates : SAMPLE_TAX_RATES;
  } catch {
    return SAMPLE_TAX_RATES;
  }
};

export const saveTaxRates = (rates: TaxRate[]) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(rates));
};
